module.exports = __webpack_public_path__ + "img/eye-in-client-leduc.40a6bc45.png";